<template>
  <div class="business_card">
    <div class="logo_area">
      <img src="@/assets/front/image/intro_logo.png" alt="동양고속" />
    </div>
    <div class="info_area">
      <button>
        <img
          src="@/assets/front/image/ic_head_exit.png"
          alt="X"
          @click.prevent="goBack"
        />
      </button>
      <div class="text">
        <p class="rank">
          <span>{{ deptName }}</span> / <span>{{ jobName }}</span>
        </p>
        <p class="name">{{ userName }}</p>
        <p class="company">(주) 동양고속</p>
        <p class="tel">Tel. 02-535-3111</p>
        <p class="mobile">Mobile. {{ handphone }}</p>
        <p class="url">www.dyexpress.co.kr</p>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@common/store';
import {
  authMapActions,
  authMapState,
  authMapGetters,
  authGetters,
  authTypes,
} from '@common/store/modules';
import { mapActions, mapState, mapGetters } from '@common/store/modules/user';
import * as actions from '@common/store/modules/user/types';
import * as getters from '@common/store/modules/user/getters';
import { nativeLandscape } from '@common/lib/common/utils';
export default {
  beforeMount() {
    nativeLandscape(1);
  },
  beforeDestroy() {
    nativeLandscape(0);
  },
  async beforeRouteEnter(to, from, next) {
    //await store.dispatch('user/USER_RESET_STATE');
    return next(vm => {
      vm.fetch();
    });
  },
  computed: {
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
      isEnterpriseUser: authGetters.IS_ENTERPRISE_USER,
    }),
    ...mapGetters({
      user: getters.USER,
    }),
    userName() {
      return this.user ? this.user.username : '';
    },
    handphone() {
      return this.user ? `${this.user.dsHandphone}` : '';
    },
    deptName() {
      return this.user ? this.user.dsDept : '';
    },
    jobName() {
      return this.user
        ? this.user.cdJobType !== '04'
          ? '관리직'
          : '승무직'
        : '';
    },
  },
  methods: {
    ...mapActions([actions.FETCH_ME]),
    async fetch() {
      this[actions.FETCH_ME]();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
